<template>
    <div class="dashboard-mod">
        <div class="head-mod">
            <a target="_blank" :href="profileUrl">
                <div class="avatar-wrap avatar" :style="{'background-image': `url('${avatarUrl}')`}"></div>
                <h2>{{nickName}}</h2>
                <p class="email">{{emailAddress}}</p>
            </a>
        </div>
        <div class="server-mod">
            <ul>
                <li class="videos">
                    <label>{{ $t("dashboard.myVideo") }}</label>
                    <span class="num no-content" v-if="!videoTotal">{{videoNum}}</span>
                    <router-link v-else class="num" :to="{ path: '/user/cloud-library/'}">{{videoNum}}
                    </router-link>
                </li>
                <li class="plans">
                    <label>{{ $t("dashboard.plan") }}</label>
                    <div class="cloud-plan">
                        <ul class="cloud-plan-list" v-if="cloudPlanShow">
                            <li>
                                <dl>
                                    <dd class="rel cloud-plan-name">
                                        <label>{{ $t("dashboard.current_plan") }}</label>
                                        <span class="title"><i :style="{
                                            'background-color': subscribe.color
                                        }"></i>{{ sub.plan | planName }}
                                        </span>
                                        <reo-tip>
                                            <div class="question-mod">
                                                <p>
                                                    <span v-if="Number( subscribe.price ) === 0">
                                                        {{ $t( 'plan.free' ) }}{{ $t('comma') }}
                                                    </span>
                                                    <span v-html="$options.filters.planHistory(sub.plan)"></span>{{ $t('comma') }}
                                                    <span v-html="$options.filters.planCamera(sub.plan)"></span>
                                                    {{ !FEATURE('dashboard.used_space') ? $t('comma') : '' }}
                                                    <span v-if="!FEATURE('dashboard.used_space')" v-html="$options.filters.planCapacity(sub.plan)"></span>
                                                </p>
                                            </div>
                                        </reo-tip>
                                    </dd>
                                    <dd>
                                        <label>{{ $t("dashboard.vaild_time") }}</label>
                                        <span class="time">{{ sub | planValidTime }}</span>
                                    </dd>
                                    <dd v-if="subscriptionStatus.ACTIVE === subscribe.status" id="cameraAssign" class="rel">
                                        <label>{{ $t("dashboard.cameras_assigned") }}</label>
                                        <span class="number"><span class="blue">{{ subscribe.devices.length }}</span>/{{ subscribe.maxCamera }}</span>
                                        <reo-tip v-if="!FEATURE('main.how_to_bind')">
                                            <div class="question-mod">
                                                <p><a :href="howToBindUrl" target="_blank">{{ $t("dashboard.how_to_bind") }} <span class="ui-icon icon-icon_arrow-right"></span></a></p>
                                            </div>
                                        </reo-tip>
                                    </dd>
                                    <dd v-if="!FEATURE('dashboard.used_space') && subscriptionStatus.ACTIVE === subscribe.status">
                                        <label id="storageSpace">{{ $t("dashboard.space") }}</label>
                                        <div class="progress-bar">
                                            <div class="space">
                                                <p class="use-space" :style="{'width': `${subscribe.percent}%`}"></p>
                                            </div>
                                            <span class="space-info">({{ $n(subscribe.usedSpace, 'decimal') }}G/{{ $n(subscribe.maxSpace, 'decimal') }}G)</span>
                                        </div>
                                    </dd>
                                    <dd class="buttons">
                                        <label for="" class="renew-label"></label>
                                        <ul class="button-content" v-if="planOptions.length">
                                            <li v-for="(option, index) in planOptions" :key="index" :class="option.note ? 'extra-style' : ''">
                                                <router-link :class="option.class" :to="option.to" :ga-label="option.gaLabel">
                                                    {{ option.label }}
                                                </router-link>
                                                <span v-if="option.note" class="red">{{ option.note }}</span>
                                            </li>
                                        </ul>
                                    </dd>
                                </dl>
                            </li>
                        </ul>
                        <div class="plan-history">
                            <p>
                                <router-link
                                v-if="!cloudPlanShow && showContent"
                                id="cloudPlanLink"
                                class="ui-button primary-button short-button"
                                ga-label="Dashboard subscribe"
                                :to="{path: '/user/subscribe-plan/'}">{{ $t("dashboard.server_plan") }}</router-link>
                            </p>
                            <router-link v-if="!$store.state.user.showBeta && !FEATURE('dashboard.payment_history')" to="/user/cloud-plan-payment-history/" class="ui-link">
                                <span class="text">{{ $t( 'dashboard.payment_history' ) }}</span>
                                <span class="ui-icon icon-icon_arrow-right"></span>
                            </router-link>
                        </div>
                    </div>
                </li>
                <li class="devices">
                    <label>{{ $t("dashboard.device") }} <i class="icon-icon_repeat refresh-device" @click="refresh"></i></label>
                    <span class="num no-content" v-if="nodevices !== ''">{{nodevices}}</span>
                    <div class="device-list-table" v-if="nodevices === ''">
                        <div class="device-thead">
                            <ul>
                                <li>{{ $t("bindCamera.uid") }}</li>
                                <li>{{ $t("bindCamera.name") }} <i ref="title" :class="['icon-icon_arrow-down', 'sort-icon', sort.label === 'title' ?  'active' : '', sortOptions.title === 'DESC' ? 'down' : 'up' ]" @click="sortChange('title')"></i></li>
                                <li>{{ $t("bindCamera.model") }}</li>
                                <li>{{ $t("bindCamera.status") }} <i ref="status" :class="['icon-icon_arrow-down', 'sort-icon', sort.label === 'planStatus' ?  'active' : '', sortOptions.planStatus === 'DESC' ? 'down' : 'up']"  @click="sortChange('planStatus')"></i></li>
                            </ul>
                        </div>
                        <div class="device-tbody">
                            <ul class="rel" v-for="(item,index) in sortDeviceList" :key="index">
                                <li>
                                    {{item.uid}}
                                    <div class="device-lab-box" v-if="isLabModel(item.model)">
                                        <span class="icon-lab lab-icon"></span>
                                        <div class="device-lab-link">
                                            <a class="ui-link" @click="accessLab">
                                                <span class="text">{{ $t("bindCamera.lab_link_hover") }}</span>
                                                <span class="ui-icon icon-icon_arrow-right"></span>
                                            </a>
                                        </div>
                                    </div>
                                </li>
                                <li>{{item.title}}</li>
                                <li>{{item.model}}</li>
                                <li>
                                    <span class="status" :class="item.planStatus">{{item.text}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="device-list-mobile" v-if="nodevices === ''">
                        <ul class="rel" v-for="(item,index) in sortDeviceList" :key="index">
                            <li>
                                <label>{{ $t("bindCamera.uid") }}</label>
                                <span>{{item.uid}}</span>
                                <div class="device-lab-box" v-if="isLabModel(item.model)">
                                    <span class="icon-lab lab-icon"></span>
                                    <div class="device-lab-link">
                                        <a class="ui-link" @click="accessLab">
                                            <span class="text">{{ $t("bindCamera.lab_link_hover") }}</span>
                                            <span class="ui-icon icon-icon_arrow-right"></span>
                                        </a>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <label>{{ $t("bindCamera.name") }}</label>
                                <span>{{item.title}}</span>
                            </li>
                            <li>
                                <label>{{ $t("bindCamera.model") }}</label>
                                <span>{{item.model}}</span>
                            </li>
                            <li>
                                <label>{{ $t("bindCamera.status") }}</label>
                                <span>
                                    <span class="status" :class="item.status">{{item.text}}</span>
                                </span>
                            </li>
                        </ul>
                    </div>
                    <p class="link" v-if="!FEATURE('main.how_to_bind')">
                        <a class="ui-link" :href="howToBindUrl"  target="_blank">
                            <span class="text">{{ $t("bindCamera.how_to_bind") }}</span>
                            <span class="ui-icon icon-icon_arrow-right"></span>
                        </a>
                    </p>
                    <p class="link bottom-lab-link" v-if="showUnlockLab">
                        <span class="icon-lab lab-icon"></span>
                        <a class="ui-link" @click="accessLab">
                            <span class="text">{{ $t("bindCamera.unlock_lab_btn") }}</span>
                            <span class="ui-icon icon-icon_arrow-right"></span>
                        </a>
                    </p>
                    <p class="link bottom-lab-link" v-if="showUseLab">
                        <span class="icon-lab lab-icon"></span>
                        <a class="ui-link" @click="accessLab">
                            <span class="text">{{ $t("bindCamera.lab_link") }}</span>
                            <span class="ui-icon icon-icon_arrow-right"></span>
                        </a>
                    </p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { config } from 'CONFIG';
import {mapGetters, mapActions} from 'vuex';
import {getDeviceList, getVideoTotalNum} from '@/api/cloud';
import {getStorageSub} from '@/api/dashboard';
import pointDialog from '@/basic/pointDialog';
import ReoTip from '@/basic/Tip';
import items from '@/basic/items';
import { orderedProductInfo, freePlanRenewable, getActivityPlanId } from '@/api/plan';
import { checkBeta } from '@/api/cart';
import { subscription as subscriptionStatus, plan as planStatus } from '@/config/status';

export default {

    components: {

        pointDialog,
        ReoTip,
        items

    },

    data () {

        return {

            deviceList: {},
            videoTotal: 0,
            subscribe: {
                devices: [],
                usedSpace: 0
            },
            cloudPlanShow: false,
            leftTime: 0,
            sortOptions: {

                status: 'DESC',
                planStatus: 'DESC'

            },
            sort: {

                label: 'planStatus',
                // DESC | ACS
                order: 'DESC'

            },
            config,
            subscriptionStatus,
            sub: null,
            showContent: false,
            showRenewBtn: false

        };

    },

    async created () {

        await checkBeta();
        let hasSub = await this._getStroageSub();
        this.showContent = true;
        if ( hasSub ) {

            this._getVideoTotalNum();
            this._getDeviceList();

        }
        let activityPlanId = await getActivityPlanId( true, this.sub );
        if ( activityPlanId ) {

            this.showRenewBtn = false;

        } else {

            this.showRenewBtn = true;

        }

    },

    computed: {

        labInfo () {

            return this.$store.getters.lab;

        },

        labModels () {

            return this.labInfo.metadata.models;

        },

        labDevices () {

            let list = this.sortDeviceList.filter( item => {

                return item.planStatus === 'assigned' && this.labModels.includes( item.model );

            });

            this.$store.commit( 'LAB_DEVICE', list );

            return list;

        },

        isApplied () {

            return this.labInfo.status !== 'inactive' && this.labInfo.enabled;

        },

        showUseLab () {

            return this.isApplied && this.labDevices.length > 0;

        },

        showUnlockLab () {

            return !this.isApplied && this.labDevices.length > 0;

        },

        profileUrl () {

            return config.accountCenterProfileUrl;

        },

        howToBindUrl () {

            return this.$t( 'dashboard.bind_url' );

        },

        videoNum () {

            return this.videoTotal === 0 ? this.$t( 'dashboard.no_video' ) : ( this.videoTotal + ' ' + this.$t( 'dashboard.video' ) + ( this.videoTotal > 1 ? 's' : '' ));

        },

        nodevices () {

            return Object.keys( this.sortDeviceList ).length > 0 ? '' : this.$t( 'dashboard.no_device' );

        },

        hasUnassigned () {

            let hasUnassigned = false;

            for ( let item in this.deviceList ) {

                if ( this.deviceList[item].status !== 'assigned' ) {

                    hasUnassigned = true;

                }

            }

            return hasUnassigned;

        },

        sortDeviceList () {

            let list = [ ...this.deviceList ].filter(( device ) => {

                return this.subscribe.devices.includes( device.uid );

            });
            let { label, order } = this.sort;

            for ( let device of list ) {

                let id = device.uid;

                /**
                 * 已与套餐绑定
                 */
                if ( this.subscribe.devices.includes( id )) {

                    device.planStatus = 'assigned';

                } else if ( device.status === 'associated' ) {

                    /**
                     * 已与账号绑定但未与套餐绑定
                     */

                    device.planStatus = 'unassigned';

                } else {

                    /**
                     * 未与账号绑定
                     */

                    device.planStatus = 'unbound';

                }

            }

            list.sort(( a, b ) => {

                return order === 'DESC' ? a[ label ].localeCompare( b[ label ] ) : b[ label ].localeCompare( a[ label ] );

            });

            list.forEach(( item, key ) => {

                if ( item.planStatus === 'assigned' ) {

                    item.text = this.$t( 'bindCamera.assigned' );

                } else if ( item.planStatus === 'unassigned' ) {

                    item.text = this.$t( 'bindCamera.unassigned' );

                } else {

                    item.text = this.$t( 'bindCamera.unassigned' );

                }

            });

            return list;

        },

        planOptions () {

            let nextSwitchableAt = this.subscribe.nextSwitchableAt;
            let planOptions = [];
            if ( this.sub.plan.status !== planStatus.DISABLED &&
                ( this.subscribe.endingAt === 0 ||
                freePlanRenewable( this.sub ) ||
                Number( this.subscribe.price ) !== 0 ) &&
                this.showRenewBtn &&
                !this.sub.plan.metadata['plan.once_per_user'] ) {

                let renewDes = {

                    to: {
                        path: '/checkout/',
                        query: {
                            plan_id: this.sub.plan.id
                        }
                    },
                    label: this.$t( 'dashboard.renew' ),
                    class: 'ui-button primary-button short-button renew-button ',
                    gaLabel: 'Dashboard renew'
                };
                planOptions.push( renewDes );

            };
            if ( subscriptionStatus.ACTIVATING !== this.sub.status && subscriptionStatus.DEACTIVATING !== this.sub.status ) {

                if ( !this.$store.state.user.showBeta && ( nextSwitchableAt === 0 || nextSwitchableAt < new Date().getTime())) {
    
                    planOptions.push({
    
                        to: '/user/update-plan/',
                        label: this.$t( 'dashboard.items.switch' ),
                        note: this.$t( 'dashboard.items.switch_note' ),
                        class: 'ui-button empty-button short-button switch-button ',
                        gaLabel: 'Dashboard switch'
    
                    });
    
                };
                if ( !this.FEATURE( 'dashboard.plan_cancel' ) && this.subscribe.status === subscriptionStatus.ACTIVE ) {
    
                    let cancelDes = {
    
                        to: `/user/cancel-plan/`,
                        label: this.$t( 'dashboard.items.cancel' ),
                        class: 'ui-link cancel-button ',
                        gaLabel: 'Dashboard cancel'
    
                    };
                    if ( this.$store.state.user.showBeta ) {
    
                        cancelDes.note = this.$t( 'dashboard.items.cancel_note' );
    
                    }
                    planOptions.push( cancelDes );
    
                }

            }
            return planOptions;

        },

        renewable () {

            return !( this.sub.plan.status === planStatus.DISABLED && !this.sub.plan.portablePlan ) &&
                ( this.subscribe.endingAt === 0 ||
                freePlanRenewable( this.sub ) ||
                Number( this.subscribe.price ) !== 0 );

        },

        ...mapGetters( [

            'avatarUrl',
            'nickName',
            'emailAddress',
            'lang'

        ] )

    },

    methods: {

        accessLab () {

            this.$emit( 'accessLab' );

        },

        isLabModel ( model ) {

            console.log( 'isLab: ', this.isApplied && this.labModels.includes( model ));
            return this.isApplied && this.labModels.includes( model );

        },

        async refresh () {

            let hasSub = await this._getStroageSub();
            if ( hasSub ) {

                this._getDeviceList();

            }

        },

        _getVideoTotalNum () {

            getVideoTotalNum().then(( res ) => {

                this.videoTotal = res;

            });

        },

        ...mapActions( [

            'topInfoToggle'

        ] ),

        async _getDeviceList () {

            let deviceList = await getDeviceList();
            this.deviceList = deviceList;

        },

        /**
         * 获取my cloud plan版块的信息
         *
         * 并且获取设备与当前套餐的绑定状态
         */
        async _getStroageSub () {

            let sub;

            /**
             * 先获取当前的订阅信息
             *
             * 如果当前没有订阅信息，则直接返回
             */

            try {

                sub = await orderedProductInfo();
                this.sub = sub;
                if ( !sub ) {

                    return false;

                }
                let plan = sub.plan;
                let res = await getStorageSub();

                if ( res ) {

                    /**
                     * 账号绑定的设备
                     */
                    this.subscribe.devices = res.devices;

                    /**
                     * 已使用的容量
                     */
                    res.usedSpace = res.usedSpace > plan['metadata']['cloud_storage.space_capacity'] ? plan['metadata']['cloud_storage.space_capacity'] : res.usedSpace;
                    let size = ( res.usedSpace / 1024 / 1024 / 1024 ).toFixed( 2 );

                    if ( size === '0.00' && res.usedSpace ) {

                        size = 0.01;

                    }

                    this.subscribe.usedSpace = size;

                }

                this.subscribe.planId = plan.id;

                this.subscribe.portablePlanId = plan.portablePlan;

                this.subscribe.planStatus = plan.status;

                this.subscribe.title = plan.title;

                this.subscribe.color = plan['metadata']['plan.display_color'];

                this.subscribe.maxCamera = plan['metadata']['cloud_storage.max_device_quantity'];

                this.leftTime = plan['metadata']['cloud_storage.video_lifetime'];

                this.subscribe.maxSpace = ( plan['metadata']['cloud_storage.space_capacity'] / 1024 / 1024 / 1024 ).toFixed( 2 );

                this.subscribe.percent = this.subscribe.usedSpace / this.subscribe.maxSpace * 100;

                this.subscribe.endingAt = sub.cycle.endingAt;

                this.subscribe.status = sub.status;

                this.subscribe.nextSwitchableAt = sub.nextSwitchableAt;

                this.subscribe.expiredAt = sub.expiredAt;

                /**
                 * pending payment时不显示套餐内容
                 */
                this.cloudPlanShow = subscriptionStatus.PENDING_PATMENT !== sub.status;

                this.subscribe.price = plan.cycle.standard.salePrice;

                return true;

            } catch ( err ) {

                console.error( err );

            }

        },

        sortChange ( _label ) {

            let { label } = this.sort;
            if ( _label === label ) {

                let _order = this.sortOptions[ _label ] === 'DESC' ? 'ASC' : 'DESC';
                this.$set( this.sortOptions, _label, _order );
                this.$set( this.sort, 'order', _order );

            } else {

                this.$set( this.sort, 'label', _label );
                this.$set( this.sort, 'order', this.sortOptions[ _label ] );

            }

        }

    }

};
</script>

<style type="text/css" lang="less">

    .dashboard-mod .head-mod{
        text-align: center;
        border-bottom: 2px solid #eff1f5;
    }

    .sort-icon{
        vertical-align: middle;
        font-size: 0.14rem;
        margin-left: 0.1rem;
        color: #ccc;
        cursor: pointer;
        transition: transform .5s;
        display: inline-block;
        &.active{
            color: #333;
        }
        &.up{
            transform: rotate(180deg);
        }
    }

    body .plan-options.reo-items{
        position: absolute;
        right: 0.3rem;
        top: 0.2rem;
        @media @mobile{
            right: 15px;
        }
        @media screen and (max-width: 320px) {
            right: 4px;
        }
    }

    .refresh-device{
        display: inline-block;
        margin-left: 0.15rem;
        vertical-align: middle;
        color: @theme;
        cursor: pointer;
    }

    .icon-question{
        font-size: .16rem;
        cursor: pointer;
        margin-left: .15rem;
        display: inline-block;
        vertical-align: top;
        position: relative;
        top: .04rem;
    }

    .cloud-plan .no-plan{
        margin-bottom: .3rem;
        text-align: left;
        font-size: .18rem;
        font-weight: 500;
        color: #777;
    }

    .devices .status{
        width: 1.06rem;
        display: inline-block;
    }

    .devices .status.unassigned{
        color: #989898;
    }

    .devices .status.assigned{
        color: #333;
    }

    .devices .status.unbound{
        color: #dd4429;
    }

    .devices .changeAssign{
        color: @theme;
        cursor: pointer;
    }

    .dashboard-mod .server-mod .no-content {
        color: #777;
        margin-bottom: .3rem;
        display: inline-block;
        vertical-align: top;
    }
    .dashboard-mod .server-mod .devices .no-content{
        @media @mobile{
            margin-left: 15px;
        }
    }

    .dashboard-mod .head-mod .avatar{
        border-radius: 50%;
        border: 1px solid #ddd;
        width: .86rem;
        height: .86rem;
        margin-bottom: .2rem;
        display: inline-block;
    }

    .dashboard-mod .head-mod h2{
        font-weight: 700;
        color: #333;
        font-size: 0.22rem;
        margin-bottom: .06rem;
    }

    .dashboard-mod .head-mod .email{
        color: #333;
        margin-bottom: .6rem;
        font-size: 0.16rem;
        font-weight: 400;
    }

    .dashboard-mod .head-mod .tripartite li{
        display: inline-block;
    }

    .dashboard-mod .head-mod .tripartite li.youtube{
        color: #C4302B;
    }

    .dashboard-mod .head-mod .tripartite li.facebook{
        color: #3B5998;
    }

    .dashboard-mod .head-mod .tripartite li.twitter{
        color: #55ACEE;
    }

    .dashboard-mod .head-mod .tripartite span{
        font-size: .3rem;
    }

    .dashboard-mod .head-mod .tripartite li + li{
        margin-left: .06rem;
    }

    .dashboard-mod .server-mod .num{
        font-weight: 500;
        color: @theme;
        font-size: .18rem;
        vertical-align: middle;
    }

    .dashboard-mod .server-mod .progress-bar {
        display: inline-block;
        @media @mobile{
            display: flex;
        }
    }

    .dashboard-mod .server-mod .space{
        background-color: #EFEFF4;
        border-radius: 2rem;
        margin-right: .2rem;
        display: inline-block;
        width: 3.16rem;
        height: .14rem;
        vertical-align: middle;
    }

    .dashboard-mod .server-mod .use-space{
        height: 100%;
        width: 65%;
        border-radius: 2rem;
        background-color: @theme;
    }

    .device-list-table{
        color: #333;
        border: 1px solid #f8f8f8;
        width: 7.6rem;
        margin-bottom: .2rem;
        font-size: 0;
        display: inline-block;
        vertical-align: top;
    }

    .dashboard-mod .device-list-table li{
        display: table-cell;
        line-height: .2rem;
        padding: .2rem;
        box-sizing: border-box;
        margin: 0;
        font-size: .16rem;
        vertical-align: middle;
    }

    .dashboard-mod .device-thead{
        background-color: #FAFBFC;
        border-bottom: 1px solid #f8f8f8;

    }

    .dashboard-mod .device-thead li{
        font-weight: 500;
    }

    .dashboard-mod .device-thead li + li{
        border-left: 1px solid #eee;
    }

    .dashboard-mod .device-tbody ul {
        border-bottom: 1px solid #f8f8f8;
        li {
            position: relative;
            & + li {
                border-left: 1px solid #f8f8f8;
            }
            .device-lab-box {
                position: absolute;
                top: 50%;
                right: 0.06rem;
                transform: translateY(-50%);
                color: #00ADE5;
                z-index: 10;
                &:hover {
                    .device-lab-link {
                        display: block;
                    }
                }
                .lab-icon {
                    font-size: 0.24rem;
                    cursor: pointer;
                }
                .device-lab-link {
                    display: none;
                    position: absolute;
                    bottom: 50%;
                    left: 100%;
                    padding: 10px 15px 8px;
                    box-shadow: 0 2px 7px 1px rgba(0, 0, 0, 0.14);
                    background-color: #FAFBFC;
                    font-size: 0.16rem;
                    font-weight: 500;
                    a {
                        white-space: nowrap;
                    }
                }
            }
        }
    }

    .dashboard-mod .device-list-table li:first-child{
        width: 2.2rem;
        max-width: 2.2rem;
    }
    .dashboard-mod .device-list-table li:nth-child(2){
        width: 1.9rem;
        max-width: 1.9rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .dashboard-mod .device-list-table li:nth-child(3){
        width: 1.8rem;
        max-width: 1.8rem;
    }
    .dashboard-mod .device-list-table li:nth-child(4){
        width: 1.7rem;
        max-width: 1.7rem;
    }

    .dashboard-mod .devices .device-list-mobile{
        padding: 0;
        margin-bottom: .3rem;
    }

    .dashboard-mod .devices .device-list-mobile ul{
        padding: .3rem 15px;
        background-color: #FAFBFC;
        font-size: 0;
        border: 1px solid #f8f8f8;
    }

    .dashboard-mod .devices .device-list-mobile ul + ul,
    .dashboard-mod .device-list-mobile li + li{
        margin-top: .3rem;
    }

    .dashboard-mod .device-list-mobile li {
        position: relative;
        label{
            font-size: .26rem;
            width: 2.94rem;
            color: #333;
            font-weight: 500;
            margin-bottom: 0;
            display: inline-block;
            vertical-align: top;
        }
        span{
            font-size: .26rem;
        }
        .device-lab-box {
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            z-index: 10;
            &:hover .device-lab-link {
                display: block;
            }
            .lab-icon {
                font-size: 0.4rem;
                color: #00ADE5;
            }
            .device-lab-link {
                display: none;
                position: absolute;
                top: 50%;
                right: 100%;
                padding: 0.17rem 0.3rem 0.17rem;
                box-shadow: 0 0.02rem 0.07rem 0.01rem rgba(0, 0, 0, 0.14);
                background-color: #FAFBFC;
                font-size: 0.26rem;
                font-weight: 500;
                a {
                    white-space: nowrap;
                }
            }
        }
    }

    .dashboard-mod .server-mod label{
        width: 2.1rem;
        display: inline-block;
        font-size: .2rem;
        font-weight: 700;
        color: #333;
        vertical-align: middle;
    }

    .dashboard-mod .server-mod>ul>li {
        margin-top: 0.9rem;
    }

    .dashboard-mod .server-mod .space-info{
        font-size: .16rem;
        font-weight: 500;
        line-height: 1;
        vertical-align: middle;
    }
    .dashboard-mod .server-mod .link{
        margin-left: 2.15rem;
        &.bottom-lab-link {
            padding-left: 0.3rem;
        }
        position: relative;
        & + .link {
            margin-top: 0.2rem;
        }
        .lab-icon {
            position: absolute;
            font-size: 0.24rem;
            color: #00ADE5;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
        }
    }

    .dashboard-mod .server-mod .remark{
        margin-left: 1.85rem;
        margin-top: .3rem;
        color: #dd4429;
        font-size: .16rem;
    }

    .blue{
        color: @theme;
    }

    .cloud-plan{
        display: inline-block;
        vertical-align: top;
        text-align: center;
        .plan-history{
            text-align: left;
            @media @mobile{
                padding-left: 15px;
            }
        }
    }

    .cloud-plan-list{
        font-size: .16rem;
        margin-bottom: 0.3rem;
    }

    .cloud-plan-list>li{
        width: 7.62rem;
        border-radius: .1rem;
        border: 1px solid #eee;
        padding: .4rem .6rem .4rem;
        box-sizing: border-box;
        text-align: center;
        background-color: #FAFBFC;
        position: relative;
    }

    .cloud-plan-list>li + li{
        margin-top: .4rem;
    }

    .dashboard-mod .cloud-plan-list li dl{
        text-align: left;
    }

    .dashboard-mod .cloud-plan-list li label{
        width: 1.8rem;
        display: inline-block;
        font-size: .16rem;
        font-weight: 500;
        vertical-align: top;
    }

    .dashboard-mod .cloud-plan-list dd + dd{
        margin-top: .2rem;
    }

    .dashboard-mod .cloud-plan-list li .span{
        font-size: .16rem;
    }

    .dashboard-mod .cloud-plan-list li .title{
        font-size: .2rem;
        font-weight: 500;
        position: relative;
        top: -.02rem;
        margin-right: .15rem;
        vertical-align: middle;
    }

    #cameraAssign .number{
        margin-right: .15rem;
    }

    #cameraAssign .number+.reo-tip{
        vertical-align: middle;
        position: relative;
        top: -0.04rem;
    }

    .dashboard-mod .cloud-plan-list li .cancel-button{
        text-align: center;
        margin-top: .1rem;
        background-color: #FAFBFC;
    }

    .dashboard-mod .cloud-plan-list .title i{
        display: inline-block;
        width: .18rem;
        height: .18rem;
        border-radius: 50%;
        margin-right: .1rem;
        vertical-align: bottom;
        position: relative;
        top: -.03rem;
        @media @mobile{
            width: .24rem;
            height: .24rem;
        }
    }

    .dashboard-mod .cloud-plan-list .title i.yellow{
        background-color: #FFAC48;
    }

    #cloudPlanLink{
        margin-bottom: .4rem;
    }

    .device-list-mobile{
        display: none;
    }

    .cloud-plan-name .reo-tip{
        top: -0.01rem;
    }

    .dashboard-mod .cloud-plan-list .buttons {
        font-size: 0;

        .button-content {
            margin-top: .1rem;
            display: inline-block;
            width: calc(100% - 180px);
        }
        li {
            display: inline-block;
            vertical-align: top;

            &.extra-style {
                position: relative;
                padding-bottom: 49px;
            }
        }
        li + li {
            margin-left: 20px;
        }
        .red {
            position: absolute;
            left: 0;
            bottom: 0;
            font-size: .16rem;
        }
        .cancel-button {
            font-size: 16px;
            line-height: 45px;
        }
    }

    @media @mobile {

        .dashboard-mod .cloud-plan-list .title i{
            top: -.06rem;
        }

        .cloud-plan{
            text-align: left;
        }

        .cloud-plan .no-plan{
            font-size: .26rem;
        }

        .cloud-plan-name .content{
            margin-left: -3rem;
        }

        .device-list-table{
            display: none;
        }

        .device-list-mobile{
            display: block;
        }

        .devices .status{
            width: 1.6rem;
        }

        .dashboard-mod .server-mod{
            padding: 0;
        }

        .dashboard-mod .server-mod .videos{
            padding: 0 15px;
        }
        .dashboard-mod .server-mod .plans > *{
            padding: 0 15px;
        }

        .dashboard-mod .server-mod .plans .cloud-plan{
            padding: 0;
            width: 100%;
            border-radius: 0;
        }
        .cloud-plan-list>li{
            border-radius: 0;
            padding: .5rem 15px;
            font-size: .26rem;
            text-align: left;
            width: 100%;
        }

        .dashboard-mod .cloud-plan-list li label{
            width: 3.2rem;
            font-size: .26rem;
            margin-bottom: 0;
        }
        .dashboard-mod .cloud-plan-list li dd + dd{
            margin-top: .3rem;
        }
        .dashboard-mod .cloud-plan-list li .title{
            font-size: .26rem;
        }
        #storageSpace,
        .dashboard-mod .cloud-plan-list li label.renew-label{
            display: none;
        }

        .dashboard-mod .head-mod .avatar {
            width: 1.2rem;
            height: 1.2rem;
            margin-bottom: .3rem;
        }

        .dashboard-mod .head-mod .email{
            font-size: .26rem;
        }
        .dashboard-mod .tripartite li span{
            font-size: .45rem;
        }

        .dashboard-mod .server-mod label{
            font-size: .32rem;
            font-weight: 500;
            display: block;
            margin-bottom: .3rem;
            width: auto;
        }

        .dashboard-mod .server-mod .num {
            font-size: .26rem;
            padding: 0;
        }

        .dashboard-mod .server-mod .space{
            height: .3rem;
            display: inline-block;
            flex-grow: 1;
        }
        .dashboard-mod .server-mod .space-info{
            font-size: .26rem;
        }

        .dashboard-mod .head-mod .tripartite li + li{
            margin-left: .2rem;
        }

        .dashboard-mod .head-mod .tripartite span {
            font-size: 0.47rem;
        }

        .dashboard-mod .head-mod h2{
            font-size: .36rem;
            margin-bottom: .08rem
        }

        .dashboard-mod .server-mod .link {
            margin: 0;
            margin-left: 15px;
            padding-left: 0;
            &.bottom-lab-link {
                padding-left: 0.52rem;
            }
            .lab-icon {
                font-size: 0.4rem;
            }
            & + .link {
                margin-top: 0.3rem;
            }
        }

        .dashboard-mod .devices{
            margin-top: 0;
        }

        .dashboard-mod .devices > *{
            padding: 0 15px;
        }

        .dashboard-mod .product-mod li .item{
            width: 3.3rem;
            padding: .3rem 0 0;
            box-sizing: border-box;
        }

        .dashboard-mod .product-mod li .item .status{
            line-height: .45rem;
            font-size: .24rem;
        }

        .dashboard-mod .product-mod li img{
            width: 1.2rem;
            height: 1.2rem;
        }

        .dashboard-mod .product-mod {
            margin-bottom: 0;
        }

        .dashboard-mod .product-mod li .name {
            font-size: 0.28rem;
            margin-bottom: .05rem;
            line-height: 1;
            font-weight: 500;
            margin-top: 0.2rem;
        }

        .dashboard-mod .product-mod li .model {
            font-size: 0.24rem;
        }

        .dashboard-mod .product-mod ul {
            max-width: 980px;
            margin: 0 auto;
        }

        .dashboard-mod .product-mod li + li {
            margin-left: 0;
        }

        .dashboard-mod .product-mod li:nth-of-type(even) {
            margin-left: 0.4rem;
        }

        .dashboard-mod .product-mod li {
            margin-bottom: 0.3rem;
        }

        #cloudPlanLink{
            line-height: .78rem;
            padding: 0 .45rem;
            font-size: .26rem;
        }

        .dashboard-mod .server-mod .remark{
            font-size: .26rem;
            margin-left: 0;
        }

        .dashboard-mod .product-mod li .cover .ui-button{
            display: block;
            width: 2.54rem;
            margin: 0 auto;
            font-size: .26rem;
            font-weight: 500;
        }

        .dashboard-mod .product-mod li .cover .ui-button + .ui-button{
            margin-top: .15rem;
        }

        .dashboard-mod .cloud-plan-list .buttons {
            .button-content {
                margin: 0 auto;
                width: 100%;
                text-align: center;
            }
            li {
                display: block;

                &.extra-style {
                    padding-bottom: 0;
                }
            }
            li + li {
                margin-left: 0;
                margin-top: .4rem;
            }
            .red {
                margin-top: .16rem;
                font-size: .24rem;
                position: static;
                display: block;
            }
            .cancel-button {
                font-size: .26rem;
                line-height: 1.6;
            }
        }

    }

</style>



// WEBPACK FOOTER //
// src/components/dashboard.vue